import * as React from "react";
const SvgFiRrLuggageCart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-luggage-cart_svg__a)">
      <path
        fill="#062147"
        d="M24 18a1 1 0 0 0-1-1H9c-1.654 0-3-1.346-3-3V5c0-2.757-2.243-5-5-5a1 1 0 1 0 0 2c1.654 0 3 1.346 3 3v9a5 5 0 0 0 2.681 4.428A3.48 3.48 0 0 0 6 20.5C6 22.43 7.57 24 9.5 24a3.504 3.504 0 0 0 3.162-5h4.677a3.504 3.504 0 0 0 3.162 5c1.93 0 3.5-1.57 3.5-3.5 0-.608-.156-1.18-.43-1.679A1 1 0 0 0 24 18m-13 2.5c0 .827-.673 1.5-1.5 1.5S8 21.327 8 20.5 8.673 19 9.5 19s1.5.673 1.5 1.5m9.5 1.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5M20 4V3c0-1.654-1.346-3-3-3h-2c-1.654 0-3 1.346-3 3v1C9.794 4 8 5.794 8 8v3c0 2.206 1.794 4 4 4h8c2.206 0 4-1.794 4-4V8c0-2.206-1.794-4-4-4m-6-1c0-.551.448-1 1-1h2c.552 0 1 .449 1 1v1h-4zm4 3v7h-4V6zm-8 5V8c0-1.103.897-2 2-2v7c-1.103 0-2-.897-2-2m12 0c0 1.103-.897 2-2 2V6c1.103 0 2 .897 2 2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-luggage-cart_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLuggageCart;
